import type { License } from "../types/api.js";
import { apiRequest } from "./api-client.js";

/**
 * Listado según rol (API real). Útil en portal para `tenant-admin` / staff.
 * `customer-portal-user` u otros roles pueden recibir 403 — manejar en UI.
 */
export async function fetchLicenses(token: string): Promise<{ licenses: License[] }> {
  return apiRequest<{ licenses: License[] }>("/api/v1/licenses", { method: "GET", token });
}
